import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';

const GLOBAL = require('../../Globals');

class Assessment extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			cls : '',
			section : '',
			astype : '',
			asname : '',
			maxmark : '',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			secs : [],
			subj : [],
			id : '',
			data : [],
			activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset Subject Allocated form **/
	onClick(e){
		
		document.getElementById("assform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.astype && this.state.asname && this.state.maxmark){
			
			PostData('exam/addassessment',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Assessment added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("assform").reset();
					this.getdata();	
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getdata();	
	}
	
	getdata(){
		
		GetData('exam/getass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('exam/deleteass',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Assessment Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Assessment',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	
  render() {
	
	var items = this.state.posts;
	
	this.type = [
		{value : '', name : 'Select'},
		{value : 'Yes', name : 'Common to All'},
		{value : 'No', name : 'Selected Section'}
	];
	  
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	if(this.state.astype == 'Yes'){
		
		$("#class").hide(1000);
		$("#sect").hide(1000);
	}
	else if(this.state.astype == 'No'){
		
		$("#class").show(1000);
		$("#sect").show(1000);
	}
	else{
		
		$("#class").hide(1000);
		$("#sect").hide(1000);
	}
  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
        <Row>
          <Col md="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Set Assessment
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Enter Assessment Mark
                </NavLink>
              </NavItem>
			  <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                  Mark List
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
				<Row>
				<Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="assform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Set Assessment</strong>
					</CardHeader>
					<CardBody>
					  <Row>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Assessment Type <span className="text-danger">*</span></Label>
							  <select name="astype" className="form-control" onChange={this.onChange} required>
								{this.type.map((e, key) => {
									return <option key={key} value={e.value}>{e.name}</option>;
								})}	
							  </select>
							</FormGroup>
						</Col>
						<Col md="12" id="class">
							<FormGroup>
							  <Label htmlFor="cls">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.onChange} className="form-control" id="clas"> 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12" id="sect">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.onChange} className="form-control" id="secs">
															
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Assessment Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="asname" required onChange={this.onChange} />
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Max.Mark <span className="text-danger">*</span></Label>
							  <Input type="text" name="maxmark" required onChange={this.onChange} />
							</FormGroup>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="7">
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Assessment Name</th>
								<th>Max.Mark</th>
								<th>Common to All</th>
								<th>Class</th>
								<th>Section</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.assname}</td>
									<td>{item.maxmark}</td>
									<td>{item.type}</td>
									<td>{item.class}</td>
									<td>{item.section}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="2">
				<Row>
				<Col md="6">
				
				</Col>
				<Col md="6">
					
				</Col>
				</Row>
			  </TabPane>
			</TabContent>
		  </Col>
		</Row>
		</div>
	);
  }
}

export default Assessment;


// WEBPACK FOOTER //
// ./src/exams/Assessment/Assessment.js